import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type EdgeGatewaysState, type EdgeGatewaysActionTypes } from 'app/store/types';

const initialState: EdgeGatewaysState = {};

const edgeGatewaysReducer = (state = initialState, action: EdgeGatewaysActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { edgeGateways },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(edgeGateways && { byId: edgeGateways }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'edgeGateways',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	edgeGatewaysReducer,
);

// Selectors
export const getEdgeGatewaysById = ({ app: { selectedLicenseGroupId }, edgeGateways }: RootState) =>
	edgeGateways[selectedLicenseGroupId].byId;

export const getEdgeGateways = createSelector([getEdgeGatewaysById], (edgeGatewaysById) =>
	Object.values(edgeGatewaysById),
);
